import { formatDate } from 'Helpers';
import { Dispatch } from 'redux';
import { ApiEndpoints, ActionHandler } from 'Utils';
import { milestoneTypes } from './Types';

export const getMilestoneCategories = () => (dispatch: Dispatch) => {
	const currentChildId = localStorage.getItem('currentChildId');
	return ActionHandler(
		{ url: `${ApiEndpoints.milestoneCategories}/${currentChildId}`, method: 'GET', dispatch },
		res => {
			const { data } = res.data;

			dispatch({ type: milestoneTypes.LOAD_CATEGORY, payload: { data } });
		},
		error => {

			dispatch({ type: milestoneTypes.LOAD_MILESTONE_FAIL, payload: { errors: error } });
		},
	);
};
export const getExerciseCategories = () => (dispatch: Dispatch) => {
	const currentChildId = localStorage.getItem('currentChildId');
	return ActionHandler(
		{ url: `${ApiEndpoints.exerciseCategories}/${currentChildId}`, method: 'GET', dispatch },
		res => {
			const { data } = res.data;

			dispatch({ type: milestoneTypes.LOAD_CATEGORY, payload: { data } });
		},
		error => {

			dispatch({ type: milestoneTypes.LOAD_MILESTONE_FAIL, payload: { errors: error } });
		},
	);
};
export const getMilestoneByCategories = (id: string) => (dispatch: Dispatch) => {
	const childId = localStorage.getItem('currentChildId');
	const newUrl = ApiEndpoints.milestonesListByCategory + `/${childId}&${id}`;
	return ActionHandler(
		{ url: newUrl, method: 'GET', dispatch },
		res => {
			const { data } = res.data;

			dispatch({ type: milestoneTypes.LOAD_MILESTONE_BY_CATEGORY, payload: { data } });
		},
		error => {
			dispatch({ type: milestoneTypes.LOAD_MILESTONE_FAIL,  payload: { errors: error }});
		},
	);
};

export const getMilestoneById = (id: string) => (dispatch: Dispatch) => {
	const childId = localStorage.getItem('currentChildId');
	const newUrl = ApiEndpoints.milestoneDetails + `/${childId}&${id}`;
	return ActionHandler(
		{ url: newUrl, method: 'GET', dispatch },
		res => {
			const { data } = res.data;

			dispatch({ type: milestoneTypes.LOAD_MILESTONE_DETAILS, payload: { data } });
		},
		error => {

			dispatch({ type: milestoneTypes.LOAD_MILESTONE_FAIL,  payload: { errors: error }});
		},
	);
};

export const saveMilestone = (milestoneId: string, selected: any) => (dispatch: Dispatch) => {

	const dateAchieved = formatDate(selected)
	const childId = localStorage.getItem('currentChildId');

	const data = JSON.stringify({ childId, milestoneId, dateAchieved });

	return ActionHandler(
		{ url: ApiEndpoints.saveMilestone, method: 'POST', dispatch, data },
		res => {
			const { data } = res.data;

			dispatch({ type: milestoneTypes.SAVE_MILESTONE });
		},
		error => {
			dispatch({ type: milestoneTypes.LOAD_MILESTONE_FAIL,  payload: { errors: error }});
		},
	);
};

export const getAgeGroup = () => (dispatch: Dispatch) => {
	const currentChildId = localStorage.getItem('currentChildId');
	return ActionHandler(
		{ url: `${ApiEndpoints.ageGroup}/${currentChildId}`, method: 'GET', dispatch },
		res => {
			const { data } = res.data;

			dispatch({ type: milestoneTypes.LOAD_AGE_GROUP, payload: { data } });
		},
		error => {
			dispatch({ type: milestoneTypes.LOAD_MILESTONE_FAIL,  payload: { errors: error }});
		},
	);
};



// export const 
